export default __webpack_public_path__ + "static/media/trr-drink-bottle-stella.821c5b75.png";